import React from 'react';
import PropTypes from 'prop-types';

import PanelSmall from './PanelSmall';
import PanelLarge from './PanelLarge';

const Panels = (props) => {
    switch (props.filterGroupCollection.panelType) {
    case 'large':
        return (
            <PanelLarge {...props} />
        );
    default:
        return (
            <PanelSmall {...props} />
        );
    }
};

Panels.propTypes = {
    filterGroupCollection: PropTypes.object.isRequired
};

export default Panels;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/Panels.jsx